import { TeamsService } from "@common/client"
import { positionsBaseKey } from "./positions"
import { makeAxiosMutation, makeNoArgsQuery, makeQuery } from "./utils"

export const teamsBaseKey = ["teams"] as const

export const teamsQuery = makeNoArgsQuery({
  serviceCall: TeamsService.listTeams,
  queryKey: teamsBaseKey,
})

export const archivedTeamsQuery = makeNoArgsQuery({
  serviceCall: () => TeamsService.listTeams({ deleted: true }),
  queryKey: [...teamsBaseKey, "archived"],
})

export const teamQuery = makeQuery({
  serviceCall: (id: string) =>
    TeamsService.get({ team_id: id, include_archived: true }),
  queryKey: (id) => [...teamsBaseKey, "detail", id],
})

export const useCreateTeamMutation = makeAxiosMutation({
  serviceCall: TeamsService.create,
  invalidates: () => [teamsBaseKey],
})

export const useUpdateTeamMutation = makeAxiosMutation({
  serviceCall: TeamsService.update,
  invalidates: () => [teamsBaseKey, positionsBaseKey],
})

export const useDeleteTeamMutation = makeAxiosMutation({
  serviceCall: TeamsService.delete,
  invalidates: () => [teamsBaseKey],
})

export const useRestoreTeamMutation = makeAxiosMutation({
  serviceCall: TeamsService.restore,
  invalidates: () => [teamsBaseKey],
})
